export const dashboards = {
  Accommodation: () => import('./Accommodation.vue'),
  Airfare: () => import('./Airfare.vue'),
  // ForwardBookings retired May 2026 — its time-window departure
  // filters were folded into Travel Tracker (formerly Traveller
  // Tracker). The /view/forwardbookings URL redirects via the
  // catch-all in menu.ts.
  DownloadReports: () => import('./DownloadReports.vue'),
  ScheduledReports: () => import('./ScheduledReports.vue'),
  ReportHistory: () => import('./ReportHistory.vue'),
  RentalCar: () => import('./RentalCar.vue'),
  ServiceFees: () => import('./ServiceFees.vue'),
  Summary: () => import('./Summary.vue'),
  Traveller: () => import('./Traveller.vue'),
}

export const admin = {
  // New Admin grouping (Phase A of the May-2026 restructure) —
  // each entry is a tabbed page that consolidates several of
  // the legacy stand-alone admin views. The legacy components
  // (TravelPolicies, TravellerMerging, etc.) still exist and
  // are rendered as tab content inside the wrappers.
  DataManagement: () => import('./DataManagement.vue'),
  SupplierManagement: () => import('./SupplierManagement.vue'),
  // "Preferred Suppliers > Airlines" — preferred-airline contract setup.
  PreferredAirlines: () => import('./PreferredSuppliers/Airlines.vue'),
  PreferredHotels: () => import('./PreferredSuppliers/Hotels.vue'),
  TmcDetails: () => import('./TmcDetails.vue'),
  CustomerSettings: () => import('./CustomerSettings.vue'),
  // Renamed from "User Management" in the same restructure —
  // component path unchanged.
  PlatformUsers: () => import('./UserManagement'),
  // Hierarchy is now a tab inside CustomerSettings, but keep
  // the lazy import here so the redirect from /config/hierarchy
  // resolves while we phase the URL change in.
  Hierarchy: () => import('./Hierarchy.vue'),
}

export const features = {
  TravellerTracker: () => import('./TravellerTracker'),
  Budgets: () => import('./Budgets.vue'),
  // Travel Agent Reports — TA-Admin-only multi-tab yield
  // analytics dashboard (May-2026). Single SFC + per-tab sub-
  // components under views/AgentReports/.
  AgentReports: () => import('./AgentReports/AgentReports.vue'),
}

export const site = {
  Terms: () => import('./Terms.vue'),
  NoEntities: () => import('./NoEntities.vue'),
  ClientSelection: () => import('./ClientSelection.vue'),
}

export const help = {
  // In-app Help — a single tabbed page hosting the Platform Guide (all
  // users) and, for TMC staff, the Admin Guide. Content is static
  // (views/Help/content/*) but rendered from a structured model so a
  // future Help Centre CMS can feed the same shape from an API.
  Help: () => import('./Help/Help.vue'),
}
